import React, { useEffect, useState, useRef, memo, useCallback } from "react";
import { connect } from "react-redux";
import axios from "axios";
import EventLabel2, { init } from "../../../components/EventLabel2/EventLabel2";
import { Grid } from "@material-ui/core";
import { combineProps } from "../../../helpers/objectHelper";
import { exhibitorStyle } from "./exhibitor.helper";
import { eventLabelGroupsConstants } from "../../constants/eventLabelGroups.contansts";
import { Carousel as RSCarousel, CarouselItem, CarouselControl, CarouselIndicators, CarouselCaption } from "reactstrap";
import { useMemo } from "react";

const defaultState = {
  exhibitors: [],
};

function ExhibitorModule(props) {
  const [state, setState] = useState(defaultState);
  const { eventId, lang, template, settings, preview,mobileLayout } = props;
  const { filterByGroup, carousel, showText } = settings;
  const stateRef = useRef();
  stateRef.current = state;



  useEffect(() => {
    init(eventId, eventLabelGroupsConstants.EXHIBITOR_LABEL_GROUP, lang);
    fetchExhibitors();
  }, []);

  const fetchExhibitors = () => {
    axios.get(`./api/meeting/exhibitor/${eventId}`).then(({ data }) => {
      setState({ ...stateRef.current, exhibitors: data });
    });
  };
  const { exhibitors } = state;

  const filterExhibitors = useCallback(() => {
    if (!exhibitors || !Array.isArray(exhibitors)) return [];
    return [
      ...exhibitors
        .filter((e) => {
          if (filterByGroup) {
            if (filterByGroup.includes(":")) {
              if (e.groupName.includes(":")) {
                return arrayCompare(e.groupName.split(":"), filterByGroup.split(":"));
              } else {
                return filterByGroup.split(":").includes(e.groupName);
              }
            } else {
              if (e.groupName.includes(":")) {
                return e.groupName.split(":").includes(filterByGroup);
              } else {
                return filterByGroup == e.groupName;
              }
            }
          } else return true;
        })
        .map((e) => {
          return e.group.map((g) => {
            g.img = g.exhibitorSettings && g.exhibitorSettings.find((x) => x.name == "LogoImage") ? g.exhibitorSettings.find((x) => x.name == "LogoImage").value : undefined;
            return g;
          });
        })
        .flat(),
    ];
  }, [exhibitors, filterByGroup]);

  const filteredExhibitors = filterExhibitors();

  if (/* !exhibitors || !Array.isArray(exhibitors) || */ !template) return null;

  const api = {
    ...state,
    ...props,
    filteredExhibitors,
    exhibitorTemplate: exhibitorStyle(template),
  };

  return <GridMap {...api} />;
}

function mapStateToProps(state) {
  return {
    template: state.template.template ? state.template.template.content : null,
  };
}
export default connect(mapStateToProps)(ExhibitorModule);

function GridMap(props) {
  const { settings, filteredExhibitors, exhibitorTemplate,mobileLayout } = props;
  const { hideText, textLeft, scroll, carousel } = settings;
  const { frame, title, subtitle, logo } = exhibitorTemplate;
  return (
    <div
      style={{
        ...frame,
        /*   padding: 10, */
        height: "100%",
        minHeight: "100%",
        display: "flex",
        flexDirection: textLeft ? "row " : "column",
      }}
    >
      {!mobileLayout && !hideText ? (
        <div
          style={{
            paddingRight: textLeft ? "10px" : undefined,
            width: textLeft ? "40%" : undefined,
          }}
        >
          <div
            id="expo-title"
            style={{
              ...title,
            }}
          >
            <EventLabel2 name="Exhibitors" groupName="DigitalMeeting.Exhibitor" />
          </div>
          <div
            id="expo-subtitle"
            style={{
              ...subtitle,
            }}
          >
            <EventLabel2 name="ExhibitorsIntruction" groupName="DigitalMeeting.Exhibitor" />
          </div>
        </div>
      ) : null}
      <Grid
        container
        className="jir-scroll"
        spacing={2}
        style={{
          flexBasis: "calc(100%)",
          width: "100%",
          margin: "0px",
          overflowX: scroll ? "auto" : "hidden",
          display: "flex",
          flexDirection: scroll ? "column" : undefined,
        }}
      >
        {carousel ? (
          <Carousel
            {...combineProps([
              props,
              {
                items: filteredExhibitors.sort((a, b) => {
                  return a.sortOrder - b.sortOrder;
                }),
                mobileLayout,
                logo,
              },
            ])}
          />
        ) : (
          filteredExhibitors
            .sort((a, b) => {
              return a.sortOrder - b.sortOrder;
            })
            .map((c, i) => {
              return (
                <React.Fragment key={i}>
                  <GridItem
                    {...combineProps([
                      props,
                      c,

                      {
                        logo,
                        scroll,
                        mobileLayout,
                        count: filteredExhibitors.length,
                        img: c.exhibitorSettings && c.exhibitorSettings.find((x) => x.name == "LogoImage") ? c.exhibitorSettings.find((x) => x.name == "LogoImage").value : undefined,
                      },
                    ])}
                  />
                </React.Fragment>
              );
            })
        )}
      </Grid>
    </div>
  );
}

function GridItem(props) {
  const { settings, count, mobileLayout, img, externalLink, logo, exhibitorId, clientKey, name, preview, lang, scroll } = props;

  const { colsPerRow, oneRow, showText } = settings;
  let rows = Math.ceil(colsPerRow / count);
  let cpr = colsPerRow;

  const { borderRadius, width, background } = logo;

  if (oneRow == true) {
    rows = 1;
    cpr = count;
  }

  const expoNavigation = () => {
    if (preview || mobileLayout) return;

    if (externalLink) window.open(externalLink, "_blank");
    else {
      window.open(`${!window.location.href.includes("localhost") ? "/interaction" : ""}/booth/${exhibitorId.toString(36)}?clientKey=${clientKey}&lang=${lang}`);
    }
  };
  let colWidth = 100 / cpr;

  return (
    <div
      style={{
        textAlign: "center",
        cursor: "pointer",
        background: background,
        borderRadius: borderRadius || "15px",
        margin: "5px",
        padding: "8px 0px",
        height: scroll ? "calc(100% - 10px)" : undefined,
        width: scroll ? width : `calc(${colWidth}% - 10px)`,
        maxWidth: scroll ? width : `calc(${colWidth}% - 10px)`,
      }}
    >
      <div className="expo-badge-item" onClick={() => expoNavigation()}>
        {img && showText != true  ? (
          <img
            style={{
              maxWidth: "90%",
              height: "auto",
              maxHeight: "100%",
              margin: "auto",
            }}
            src={img}
          />
        ) : (
          <p>{name}</p>
        )}
      </div>
    </div>
  );
}

function arrayCompare(_arr1, _arr2) {
  if (!Array.isArray(_arr1) || !Array.isArray(_arr2) || _arr1.length !== _arr2.length) {
    return false;
  }

  // .concat() to not mutate arguments
  const arr1 = _arr1.concat().sort();
  const arr2 = _arr2.concat().sort();

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] == arr2[i]) {
      return true;
    }
  }

  return false;
}

const Carousel = ({ items, exhibitorId, clientKey, lang, settings, filterByGroup, logo,mobileLayout }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const { colsPerRow, oneRow } = settings;
  const cols = parseInt(colsPerRow);
  const { background, borderRadius } = logo;

  useEffect(() => {
    setTimeout(() => next(), 2500);
  }, []);

  const expoNavigation = (expo) => {
     if (/* preview ||  */mobileLayout) return;
    if (!expo) return;
    if (expo.externalLink) window.open(expo.externalLink, "_blank");
    else {
      window.open(`${!window.location.href.includes("localhost") ? "/interaction" : ""}/booth/${expo.exhibitorId.toString(36)}?clientKey=${clientKey}&lang=${lang}`);
    }
  };

  const slides = useMemo(() => {
    let tempArr = [];

    const pc = 100 / cols;
    const slidesCount = Math.ceil(items.length / cols);
    for (let index = 0; index < slidesCount; index++) {
      let startIndex = index == 0 ? 0 : index * cols;
      let endIndex = /* startIndex > items.length ? items.length : */ startIndex + cols;
      tempArr.push(
        <CarouselItem style={{ height: "100%", width: "100%" }} onExiting={() => setAnimating(true)} onExited={() => setAnimating(false)} key={index}>
          <div key={index + cols} style={{ width: "100%", height: "100%", position: "relative", display: "flex", justifyContent: "center", paddingTop: 25 }}>
            {items.slice(startIndex, endIndex).map((im, i) => {
              return (
                <div
                  key={i}
                  onClick={() => expoNavigation(im)}
                  style={{
                    cursor: "pointer",
                    maxHeight: "100%",
                    width: "100%",
                    maxWidth: `calc(${pc + "%"} - 10px)`,
                    maxHeight: "calc(100% - 50px)",
                    display: "flex",
                    background: background,
                    borderRadius: borderRadius || "15px",
                    padding: "8px 0px",
                    margin: "0px 5px",
                  }}
                >
                  <img onClick={() => expoNavigation(im)} style={{ cursor: "pointer", maxWidth: "90%", /* width: "100%",  */ maxHeight: "100%", height: "auto", margin: "auto" }} src={im.img} />
                </div>
              );
            })}
          </div>
        </CarouselItem>
      );
    }

    return tempArr;
  }, [items, colsPerRow, filterByGroup]);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === slides.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? slides.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  if (!items || items.length === 0) return null;
  return (
    <RSCarousel style={{ height: "100%", overflow: "hidden", width: "100%" }} activeIndex={activeIndex} next={next} previous={previous}>
      {slides}
      <div style={{ display: "flex" }}>
        <CarouselIndicators items={slides} activeIndex={activeIndex} onClickHandler={goToIndex} />
        <CarouselControl style={{ color: "red" }} direction="prev" directionText="Previous" onClickHandler={previous} />
        <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
      </div>
    </RSCarousel>
  );
};
